import * as React from 'react';
import { Dropdown } from '@shared/ui-react/Dropdown';
import { Button } from '@shared/ui-react/Button';
import { IconsEntries, SvgIcons } from '@shared/map/MapIcons';
import './IconPicker.scss';

export class IconPicker extends React.Component<{
    selectedId: string,
    onChange?: (id: string) => void,
    disabled?: boolean
}, {}> {
    state = {
        isOpen: false,
        selectedIdUncontrolled: null
    };
    dropdownRef: HTMLDivElement = null;

    componentDidMount() {
        if (!this.isControlled) {
            this.setState({
                selectedIdUncontrolled: this.props.selectedId
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.selectedId != prevProps.selectedId) {
            if (!this.isControlled) {
                this.setState({
                    selectedIdUncontrolled: this.props.selectedId
                });
            }
        }
    }

    render() {
        const { selectedId: selectedIdControlled } = this.props;
        let selectedId = this.isControlled ? selectedIdControlled : this.state.selectedIdUncontrolled;

        return (
            <Dropdown closeOnBodyClick={false}
                      isOpen={this.state.isOpen}
                      onToggle={this.toggle}
                      buttonStyle={{ display: 'inline-flex', minWidth: 20, width: 'auto' }}
                      className="filetree-select-react__button ik-button-secondary"
                      disabled={this.props.disabled}
                      lazyRender={true}>

                <div className="icon-picker-dropdown-trigger flex-row ai-center" ref={el => this.dropdownRef = el}>
                    {SvgIcons[selectedId] ?
                        <div dangerouslySetInnerHTML={{ __html: SvgIcons[selectedId] }}></div>
                        :
                        <i className="iki iki-cross"></i>
                    }
                </div>

                <div className='icon-picker-dropdown'>
                    {IconsEntries.map(([id, icon]) => {
                        return <Button secondary subtle key={id} onClick={() => this.onChange(id)}>
                            <span dangerouslySetInnerHTML={{ __html: icon }}></span>
                        </Button>
                    })}
                </div>
            </Dropdown>
        );
    }

    toggle = _.debounce(s => {
        this.setState({ isOpen: s });
    }, 10);

    onChange = (id: string) => {
        console.log('onChange:', id);
        this.setState({ isOpen: false });
        this.setSelectedId(id);
    };

    clearSelection = () => {
        this.setSelectedId(null);
    }

    setSelectedId = (id: string) => {
        if (this.isControlled) {
            this.props.onChange(id);
        } else {
            this.setState({ selectedIdUncontrolled: id });
        }
    }

    get isControlled() {
        return typeof this.props.onChange === 'function';
    }
}
